export const is3LevelThaiWord = (str) => {
  const highWords = ['ครั้ง']
  return highWords.some((v) => str.includes(v))
}
